import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import Draggable from "react-draggable";
import { Form, Spinner } from "react-bootstrap";
import { consultantServices } from "../../../APIServices/Editor/consultantServices";
const UpdateDevelopmentFolderModal = ({
  show,
  title,
  bounds,
  submit,
  setShow,
  onStart,
  disabled,
  onMouseOut,
  draggleRef,
  onMouseOver,
  folderData,
  type,
  getProjectFolderStructured,
}) => {
  let [folderName, setFolderName] = useState("")
  const [loader, setLoader] = useState(false);

  const updateDevelopmentFolderData = async () => {
    setLoader(true);
    let userData = {};
    userData.id = folderData?._id;
    userData.name = folderName;
    let data = await consultantServices.updateDevelopmentFolderData(userData);
    if (data?.statusCode === 200) {
      setShow(false);
      setLoader(false);
      setFolderName("");
      getProjectFolderStructured(folderData?._id, type);
    }
  };

  useEffect(() => {
    setFolderName(folderData?.name);
  }, [folderData]);

  return (
    <>
      <Modal
        title={
          <div
            className="modal_Heading"
            onMouseOver={() => {
              if (disabled) {
                onMouseOver();
              }
            }}
            onMouseOut={onMouseOut}
          >
            <h5>{title}</h5>
          </div>
        }
        width={400}
        open={show}
        onOk={() => setShow(!show)}
        onCancel={() => setShow(!show)}
        modalRender={(modal) => (
          <Draggable
            disabled={disabled}
            bounds={bounds}
            nodeRef={draggleRef}
            onStart={(event, uiData) => onStart(event, uiData)}
          >
            <div ref={draggleRef}>{modal}</div>
          </Draggable>
        )}
      >
        <div className="common_css">
          <Form.Label>
            Folder Name<span>*</span>
          </Form.Label>
          <Form.Control
            required
            type="text"
            value={folderName}
            onChange={(e) => setFolderName(e.target.value)}
            placeholder="Enter Folder Name"
            autoFocus
          />
        </div>
        <hr className="w-100 m-0" />
        <div className="button_type footer_btn text-end px-3 pt-2">
          <button
            disabled={!folderName}
            onClick={updateDevelopmentFolderData}
          >
            {loader ? (
                <Spinner
                  animation="border"
                  style={{ width: 13, height: 13 }}
                  className="me-1"
                />
              ) : null}
            {submit}
          </button>
        </div>
      </Modal>
    </>
  );
};
export default UpdateDevelopmentFolderModal;
